/** Header-action builder for a project's Overview tab: Run workflow
 *  and Project details, the same three the native project screen offers. No JSX. */

import { Info, Zap } from '@/shared/ui/icons';
import {
  PROJECT_OVERVIEW_DETAILS_EVENT,
  PROJECT_OVERVIEW_WORKFLOW_EVENT,
  type ProjectOverviewHeaderState,
} from '../../../features/projects/detail/overview/projectOverviewHeader';
import type { MobileHeaderAction } from './types';

const fire = (name: string) => () => window.dispatchEvent(new CustomEvent(name));

export function buildProjectOverviewHeaderActions(ctx: {
  state: ProjectOverviewHeaderState;
  trailingActions: MobileHeaderAction[];
}): void {
  const { state, trailingActions } = ctx;
  if (state.canRunWorkflow) {
    trailingActions.push({ id: 'project-overview-workflow', icon: Zap, desktopLabel: 'Run workflow', ariaLabel: 'Run a workflow', group: 'create', onClick: fire(PROJECT_OVERVIEW_WORKFLOW_EVENT) });
  }
  trailingActions.push({ id: 'project-overview-details', icon: Info, ariaLabel: 'Project details', expanded: state.detailsOpen === true, group: 'inspector', onClick: fire(PROJECT_OVERVIEW_DETAILS_EVENT) });
}
